import { useEffect } from "react";

/**
 * This React hook runs the passed function exactly once when the component is mounted
 * @param f The function to run
 */
export function useOnMount(f: () => void) {
    useEffect(f, []); // eslint-disable-line react-hooks/exhaustive-deps
}
